import { render, staticRenderFns } from "./CreateFollowup.vue?vue&type=template&id=2292c2e4&scoped=true"
import script from "./CreateFollowup.vue?vue&type=script&lang=js"
export * from "./CreateFollowup.vue?vue&type=script&lang=js"
import style0 from "./CreateFollowup.vue?vue&type=style&index=0&id=2292c2e4&prod&lang=scss&scoped=true"
import style1 from "./CreateFollowup.vue?vue&type=style&index=1&id=2292c2e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292c2e4",
  null
  
)

export default component.exports